import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { PageTopbar } from "@/components/page-topbar";
import { Button } from "@/components/button";
import { useLocation, useNavigate } from "react-router-dom";
import ObjectsCard from "./object-card";
import {
  TableList,
  TableListBody,
  TableListHeader,
  TableListPagination,
  TTableListHeaderItem,
} from "@/components/table-list";
import { Loader } from "@/components/loader";
import { IdefaultSearchParams, TOrderBy } from "@/models/types";
import { defaultSearchParams, getQueryParamsFromUrl, setParamsToUrl } from "src/utils/search-utils";
import { PrivateRoute } from "@/layouts/private-route";
import { getObjects } from "@/reducers/object-search.reducer";
import { openModal } from "@/reducers/modal-reducer";
import ObjectEdit from "./object-edit";
import { defaultObject } from "src/utils/utils";

export const ObjectsSearch = () => {
  const dispatch = useAppDispatch();
  const objectsState = useAppSelector((state) => state.objectsSearch);

  const location = useLocation();
  const navigate = useNavigate();

  const [params, setParams] = useState<IdefaultSearchParams>(
    getQueryParamsFromUrl(defaultSearchParams, location)
  );

  const onNewObject = () => {
    dispatch(
      openModal({
        element: <ObjectEdit object={defaultObject} />,
        opt: { size: "xs", title: "Nuovo oggetto" },
      })
    );
  };

  const onChangePage = (page: number) =>
    setParams({
      ...params,
      offset: params.size * page,
    });

  const getCurrentPage = Math.floor(params.offset / params.size);

  const onChangeSort = (sort: TOrderBy) => () =>
    setParams({
      ...params,
      orderBy: sort,
      order: params.order === "ASC" ? "DESC" : "ASC",
    });

  const tableHeader: TTableListHeaderItem[] = [
    {
      id: "title",
      name: "Titolo",
      onClick: onChangeSort("title"),
    },
    {
      id: "createdDate",
      name: "Data creazione",
      onClick: onChangeSort("createdDate"),
    },
    {},
  ];

  useEffect(() => {
    dispatch(getObjects(params));
    setParamsToUrl(params, navigate);
  }, [params.orderBy, params.order, params.offset, params.size, objectsState.refresh]);

  useEffect(() => {
    setParams(getQueryParamsFromUrl(defaultSearchParams, location.search));
  }, [location.search]);

  return (
    <PrivateRoute>
      <>
        <PageTopbar title={"Oggetti"}>
          <div className="button-group ml-auto">
            <Button className="button md solid primary" onClick={onNewObject}>
              Nuovo oggetto
            </Button>
          </div>
        </PageTopbar>

        {objectsState.loading && <Loader color="#000000" />}
        {objectsState.fetchFailure && "Errore caricamento dati"}
        {!objectsState.loading && objectsState.search?.length === 0 && "Nessun dato"}

        {objectsState.search?.length > 0 && (
          <>
            <TableList className="color-black">
              <TableListHeader items={tableHeader} sortBy={params.orderBy} sortDirection={params.order} />
              <TableListBody>
                {objectsState.search?.map((author) => (
                  <ObjectsCard key={author.ID} object={author} />
                ))}
              </TableListBody>
            </TableList>
            <TableListPagination
              activePage={getCurrentPage}
              paginate={onChangePage}
              itemsPerPage={params.size}
              totalItems={objectsState.count}
            />
          </>
        )}
      </>
    </PrivateRoute>
  );
};
